<template>
    <section id="mainContainer">
      <section class="login-page">
        <div class="email-sent-container">
          <div class="admin-white-bg email-sent-content">
            <h1>{{ constants.EMAIL_HAS_BEEN_SENT_TEXT }}</h1>
            <div class="email-sent-text">
              <p>{{ constants.WE_HAVE_SENT_YOU_AN_EMAIL_AT_TEXT }}</p>
              <strong>{{ email }}</strong>
              <p>{{ constants.PLEASE_CLICK_THE_LINK_TO_RESET_THE_PASSWORD_TEXT }}</p>
            </div>
            <div class="email-sent-icon">
              <img src="@/assets/images/admin-img/email-sent-icon.svg" alt="Email Sent Icon" />
            </div>
            <div class="email-sent-text">
              <p>{{ constants.THE_LINK_WILL_BE_VALID_FOR_5_MINUTES_TEXT }}</p>
              <p>
                {{ constants.DID_NOT_RECEIVE_THE_EMAIL_TEXT }}
                <a href="#" id="resendEmailLink" @click="sendEmail">{{ constants.RESEND_EMAIL_LINK }}</a>
              </p>
            </div>
            <div class="primary-btn-container">
              <button id="emailSentSubmitBtn" class="primary-btn" @click="$router.push('/authority/login')">{{ constants.LOGIN_BUTTON }}</button>
            </div>
          </div>
        </div>
      </section>
      <footer class="admin-site-footer">
        <div class="container">
          {{ constants.COPYRIGHT_TEXT }}
        </div>
      </footer>
    </section>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import constants from "@/utils/en-US-Admin.json";
  import { API_BASE_URL } from '@/config/api.config';
  import axios from 'axios';
import Swal from 'sweetalert2';
  
  export default defineComponent({
    name: 'EmailSent',
    data() {
      return {
        constants,
        email: this.$route.query.email || ''
      };
    },
    methods: {
        async sendEmail() {
        try {
          const response = await axios.post(API_BASE_URL + '/send-link/', {
            email: this.email
          });
          if (response.status === 200) {
            Swal.fire({
          icon: 'success',
          title: 'Email Sent Successfully',
          showConfirmButton: false,
          timer: 1500
        });
            this.$router.push({ path: '/authority/email-sent', query: { email: this.email } });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    
  });
  </script>